<template>
  <div class="fullscreen">
    <mdb-navbar position="top" transparent color="mdb" dark scrolling>
      <mdb-navbar-brand href="#"
        ><strong>شرکت برنامه نویسان دانش برتر سهند</strong></mdb-navbar-brand
      >
      <mdb-navbar-toggler> </mdb-navbar-toggler>
    </mdb-navbar>

    <section class="view intro-2">
      <div class="mask rgba-gradient">
        <div
          class="
            container
            h-100
            d-flex
            justify-content-center
            align-items-center
          "
        >
          <div class="d-flex align-items-center content-height">
            <div class="row flex-center pt-5 mt-3">
              <div class="col-md-12 text-center text-md-rigth mb-5">
                <div class="white-text">
                  <h1
                    class="h1-responsive font-weight-bold wow fadeInLeft"
                    data-wow-delay="0.3s"
                    v-text="title"
                  ></h1>
                  <hr class="hr-light wow fadeInLeft" data-wow-delay="0.3s" />
                  <h6
                    class="wow fadeInLeft"
                    data-wow-delay="0.3s"
                    v-text="body"
                  ></h6>
                  <br />
                  <mdb-btn @click="back" outline="white" rounded>برگشت</mdb-btn>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import {
  mdbNavbar,
  mdbNavItem,
  mdbNavbarNav,
  mdbNavbarToggler,
  mdbBtn,
  mdbInput,
  mdbNavbarBrand,
  mdbTextarea,
} from "mdbvue";

export default {
  name: "Landing",
  components: {
    mdbNavbar,
    mdbNavItem,
    mdbNavbarNav,
    mdbNavbarToggler,
    mdbBtn,
    mdbInput,
    mdbNavbarBrand,
    mdbTextarea,
  },
  data() {
    return {
      title: null,
      body: null,
    };
  },
  mounted() {
    let error = this.$route.params.error;
    if(error==undefined) {
      error = null;
    }
    switch (error) {
      case 500: {
        this.title = "خطا 500";
        this.body = "خطای غیر قابل پیش بینی رخ داد است ما تلاش می کنیم";
        break;
      }
      default: {
        this.title = "خطا 401";
        this.body = "درخواست شما یافت نشد";
      }
    }
  },
  methods:{
    back(){
      // console.log(this.$router)
      this.$router.go(-1);
    }
  }
};
</script>

<style scoped>
.intro-2 {
  background: url("https://mdbootstrap.com/img/Photos/Others/img%20(42).jpg")
    no-repeat center center;
  background-size: cover;
  height: 100vh;
}

.navbar {
  background: transparent;
}

.rgba-gradient {
  background: -webkit-linear-gradient(
    45deg,
    rgba(83, 125, 210, 0.4),
    rgba(178, 30, 123, 0.4) 100%
  );
  background: -webkit-gradient(
    linear,
    45deg,
    from(rgba(29, 236, 197, 0.4)),
    to(rgba(96, 0, 136, 0.4))
  );
  background: linear-gradient(
    45deg,
    rgba(29, 236, 197, 0.4),
    rgba(96, 0, 136, 0.4) 100%
  );
}

.card {
  background-color: rgba(229, 228, 255, 0.2);
}
</style>
